<template>
  <div :class="['featured-articles', `${source}-theme`]">
    <v-container class="featured-articles__top" v-if="title">
      <v-heading level="h2">{{title}}</v-heading>
      <router-link :to="href">
        ver todas <i class="icon-arrow"></i>
      </router-link>
    </v-container>
    <v-mockup v-if="isLoading" tag="ul" :counter="3" widget="article" />
    <swiper v-else :options="options" class="featured-articles__items">
      <swiper-slide v-for="(article, index) in articles" :key="index" class="item">
        <v-article v-bind="article" :source="source" />
      </swiper-slide>
    </swiper>
    <div class="featured-articles__bottom">
      <button class="prev" ref="prev">
        <i class="icon-arrow" alt="Anterior"></i>
      </button>
      <div class="pagination" ref="pagination"></div>
      <button class="next" ref="next">
        <i class="icon-arrow" alt="Próximo"></i>
      </button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapState } from 'vuex';
import Article from '@/components/articles/Article.vue';
import Container from '@/components/layout/Container.vue';
import Heading from '@/components/uikit/text/Heading.vue';
import Mockup from '@/components/uikit/mockup/Mockup.vue';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
// eslint-disable-next-line
import 'swiper/dist/css/swiper.css';

export default {
  name: 'FeaturedArticles',
  components: {
    'v-heading': Heading,
    'v-mockup': Mockup,
    'v-article': Article,
    'v-container': Container,
    swiper,
    swiperSlide,
  },
  props: {
    source: {
      type: String,
      default: 'article',
    },
    title: {
      type: String,
      default: null,
    },
    href: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      options: {
        slidesPerView: 4,
        spaceBetween: 16,
        breakpoints: {
          1441: {
            slidesPerView: 3,
          },
          944: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 1,
            centeredSlider: true,
          },
        },
        pagination: {
          clickable: true,
          dynamicBullets: true,
        },
      },
    };
  },
  computed: {
    ...mapState({
      articles: state => state.articles.featured.items,
    }),
    ...mapGetters({
      isLoading: 'articles/featured/isLoading',
    }),
  },
  async created() {
    await this.$store.dispatch('articles/featured/getItems', this.source);
  },
  mounted() {
    Vue.set(this.options.pagination, 'el', this.$refs.pagination);
    Vue.set(this.options, 'navigation', {
      prevEl: this.$refs.prev,
      nextEl: this.$refs.next,
    });
  },
};
</script>

<style lang="scss" scoped>
$component: '.featured-articles';
#{$component} {
  overflow: hidden;
  position: relative;
  padding: $section-gutter 0;
  .swiper-container {
    overflow: visible;
    justify-content: center;
  }
  .mockup {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: $gutter-l;
    @media screen and (max-width: #{$brakepoint-medium}) {
      display: block;
    }
  }
  &__top {
    display: flex;
    align-items: center;
    margin-bottom: $gutter-xxl;
    h2 {
      flex: 1;
      margin: 0;
      color: $color-d;
    }
    a {
      display: inline-flex;
      align-items: center;
      text-decoration: none;
      font-size: $font-size;
      color: $color-sys-e;
      i {
        margin-left: $gutter-l;
        transition: transform $transition-duration $transition-timing-function;
      }
      &:hover {
        opacity: 0.8;
        i {
          transform: translateX(15%);
        }
      }
    }
  }
  &__items {
    margin-bottom: $gutter-xxl;
    padding-left: $gutter-l;
    padding-right: 10vw;
    .item {
      height: auto;
    }
  }
  @include swiper-pagination(#{$component + '__bottom'});
  &.article-theme {
    #{$component}__bottom .pagination /deep/ .swiper-pagination-bullet-active-main {
      background-color: $color-e;
    }
  }
  &.publication-theme {
    #{$component}__bottom .pagination /deep/ .swiper-pagination-bullet-active-main {
      background-color: $color-d;
    }
  }
  &.medical-area-theme {
    #{$component}__bottom .pagination /deep/ .swiper-pagination-bullet-active-main {
      background-color: $color-c;
    }
  }
}
</style>
